/* eslint-disable */
import UseAxios from '../../../../Api/http/http';
import { roleMapList } from '../../../../Api/request/roleMap';
import { AUTHENTICATION_FAILED, SET_TARGET } from '../../../../Constants/strings';

export const hasAccess = (action, permissions) => {
  return permissions.includes(action);
};

export const getUsersData = async (setRows, snackbarOpen) => {
  const token = localStorage.getItem('userRolesToken');
  try {
    const response = await UseAxios(roleMapList(token));
    const result = response.data.userRoleList;
    const users = result.map(({ roleName,projectAllocation, ...user }) => ({
      ...user,
      id: user.employeeId,
      USER_ID: user.employeeId,
      roleNames: roleName || 'NA',
      projectAllocation: projectAllocation || 'NA',

    }));
    setRows(users);
  } catch (err) {
    setRows([]);
    if (err.response?.status === 401) {
      snackbarOpen(`${AUTHENTICATION_FAILED}`, 'warning');
    } else {
      snackbarOpen(`${SET_TARGET.OOPS_TRY_AGAIN}`, 'warning');
    }
  }
};
